const commonAndMisc = {
  errorMessage404: "¡Uy! La página que buscas no existe", // translated
  backToHome: "De vuelta a casa", // translated
  information: "Información", // translated
  additionalInformation: "información adicional", // translated
  destinationPlaceholder: "Adónde vas", // translated
  aboutUs: "Sobre nosotros", // translated
  pleaseWait: "Espere por favor...", // translated
  featuredHotels: "Hoteles destacados", // translated
  topPackages: "Paquetes principales", // translated
  topTours: "Los mejores recorridos", // translated
  traveller: "Viajero", // translated
  reviews: "Reseñas", // translated
  home: "Casa", // translated
  packages: "Paquetes", // translated
  experiences: "Experiencias", // translated
  close: "Cerrar", // translated
  loadingMessage: "Espere mientras buscamos los mejores precios disponibles", // translated
  loadingMessageTheHotelCo: "Espere mientras buscamos los mejores precios disponibles", // translated
  loadingMessageSearchStrip: "Espere mientras buscamos los mejores precios disponibles...", // translated
  topCountriesToVisit: "Principales países para visitar", // translated
  profile: "Perfil", // translated
  reservations: "Reservas", // translated
  address: "Dirección", // translated
  firstName: "Primer nombre", // translated
  lastName: "Apellido", // translated
  email: "Correo electrónico", // translated
  login: "Acceso", // translated
  logout: "Cerrar sesión", // translated
  myProfile: "Mi perfil", // translated
  myChatRooms: "Mis chats", // translated 
  chatRoomsListEmpty: "No tienes salas de chat para esta cuenta.", // translated 
  chatRoomsOpen: "Abierto", // translated 
  chatRoomsLastActivity: "Última actividad", // translated 
  chatRoomsUnread: "No leído", // translated 
  chatRoomsBadgeQuotation: "Presupuesto", // translated 
  chatRoomsBadgeTripOffer: "Oferta de viaje", // translated 
  chatRoomsOpenQuotationAria: "Abrir chat de presupuesto: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Chat de ofertas de viaje abiertas: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Abrir chat: {{name}}", // translated 
  quotationChatInvalidLink:
    "Enlace de chat no válido. Abra un chat desde su perfil o la lista de presupuestos, o use exactamente uno de room_code o room_uid.", // translated 
  quotationChatNoTripDetails: "Los detalles del viaje no están disponibles para este chat.", // translated 
  chat: "Charlar", // translated 
  verified: "Verificado", // translated
  unverified: "Inconfirmado", // translated
  selectLanguage: "Seleccione el idioma", // translated
  selectCurrency: "Seleccione el tipo de moneda", // translated
  upgrade: "Mejora", // translated
  membership: "Afiliación", // translated
  travelTrust: "Fideicomiso de viaje", // translated
  signInUp: "Iniciar sesión/Registrarse", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "hoteles y resorts en todo el mundo a increíbles precios al por mayor", // translated
  dashboard: "Panel", // translated
  pricing: "Precios", // translated
  refundable: "Reintegrable", // translated
  cars: "Coches", // translated
  cruises: "Cruceros", // translated
  view: "Vista", // translated
  price: "Precio", // translated
  totalPrice: "Precio total", // translated
  filterRoomName: "Filtrar el nombre de la habitación", // translated
  get: "Conseguir", // translated
  guestInformationValidation: "Validación de la información del huésped", // translated
  reservation: "Reserva", // translated
  checkIn: "Registrarse", // translated
  checkOut: "Verificar", // translated
  paymentInitiattionErroeMessage: "No pudimos iniciar su proceso de pago. Lamentamos las molestias.", // translated
  warning: "Advertencia", // translated
  couldNotFindPriceForDateWarning: "No pudimos encontrar un precio para esta fecha. Vuelva a intentarlo para una fecha diferente", // translated
  searchFormValidationError: "Error de validación del formulario de búsqueda", // translated
  pleaseSelectValidDateFirst: "Seleccione primero una fecha válida", // translated
  searchError: "Error de búsqueda", // translated
  priceSearchInitiationError: "No pudimos iniciar el proceso de búsqueda de precios. Por favor, inténtelo de nuevo más tarde. Lamentamos las molestias.", // translated
  searchWarning: "Advertencia de búsqueda", // translated
  couldNotFindPriceAndOrAvailability: "No pudimos encontrar precio y/o disponibilidad para su solicitud. Lamentamos las molestias.", // translated
  joinNow: "Únete ahora", // translated
  signIn: "Iniciar sesión", // translated
  searchNow: "Buscar ahora", // translated
  bookingFailed: "Reserva fallida", // translated
  sorryForTheInconvenience: "Lamentamos las molestias.", // translated
  paymentFailedTryAgain: "Pago fallido. Inténtalo de nuevo", // translated
  quickLinks: "enlaces rápidos", // translated
  tours: "Excursiones", // translated
  termsAndConditions: "Términos y condiciones", // translated
  pleaseWaitWhileInitiatingPayment: "Espere mientras iniciamos su proceso de pago", // translated
  back: "Atrás", // translated
  nextStep: "Próximo paso", // translated
  book: "Libro", // translated
  checkout: "Verificar", // translated
  specifyPickUpPoint: "Especifique el punto de recogida de su preferencia", // translated
  pickupPoint: "Punto de recogida", // translated
  optional: "Opcional", // translated
  remarks: "Observaciones", // translated
  travellerInformation: "Información del viajero", // translated
  bookingRemarks: "Comentarios de la reserva", // translated
  bookingOverview: "Descripción general de la reserva", // translated
  paymentFailed: "Pago fallido", // translated
  paymentSuccess: "pago exitoso", // translated
  at: "En", // translated // translated 
  person: "persona", // translated
  cancellationPolicy: "Política de cancelación", // translated
  From: "Desde", // translated
  to: "paraca", // translated // translated 
  cancellationIs: "la cancelación es", // translated
  pickup: "Recoger", // translated
  flights: "Vuelos", // translated
  Accommodation: "Alojamiento", // translated
  payAndBook: "Pagar y reservar", // translated
  onRequest: "Bajo pedido", // translated
  weAreFindingTheBestAvailableServices: "Estamos encontrando los mejores servicios disponibles.", // translated
  withTheBestAvailablePrices: "con los mejores precios disponibles", // translated
  inRealTime: "en tiempo real", // translated
  seconds: "segundos", // translated
  thisProcessCanTakeUpToOneMinute: "Este proceso puede tardar hasta 1 minuto.", // translated
  pleaseDoNotRefreshThisPage: "Por favor, no actualices esta página.", // translated
  wellItSeemsItCanTakeBitLonger: "Bueno... parece que puede llevar un poco más de tiempo.", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Su navegador no soporta la etiqueta de vídeo", // translated
  bookingSuccess: "Éxito de reserva", // translated
  bookingReference: "Referencia de reserva", // translated
  referenceCopied: "Referencia copiada", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "En breve recibirá un correo electrónico con toda la información necesaria para su reserva", // translated
  viewMore: "Ver más", // translated
  readMore: "Lee mas", // translated
  customerSupport: "Atención al cliente", // translated
  socialMedia: "Medios de comunicación social", // translated
  lastNameIsRequired: "Se requiere apellido", // translated
  reference: "Referencia", // translated
  found: "Encontró", // translated
  emailHasBeenSent: "Correo electrónico enviado correctamente", // translated
  hours: "horas", // translated
  sendUsEmail: "Envianos un email", // translated
  currency: "Divisa", // translated
  pending: "Pendiente", // translated
  applicationAvailable: "aplicación disponible", // translated
  invalidEmail: "Email inválido", // translated
  clearYourFilters: "Borre las opciones de filtro para ver los resultados.", // translated
  lastNameMustContainAlphabetic: "El apellido debe contener únicamente caracteres alfabéticos.", // translated
  minutes: "minutos", // translated
  memberId: "Identificación de miembro", // translated
  sendUsYourRequest: "Envíanos tu solicitud", // translated
  titleIsRequired: "Se requiere título", // translated
  minute: "minuto", // translated
  distanceFromSelection: "Distancia de la selección", // translated
  noOptionsForSelectedFilters: "No hay opciones disponibles para hacer coincidir tus filtros", // translated
  sendVoucherEmail: "Enviar vale por correo electrónico", // translated
  clearAllFilters: "Limpiar todos los filtros", // translated
  phoneNumberInTheFormat: "El número de teléfono debe estar en el formato sin espacios.", // translated
  postalCodeIsRequired: "Se requiere código postal", // translated
  errorContentUnavailable: "¡Ups! El contenido que buscas no existe. Por favor contáctenos sobre el problema", // translated
  restaurants: "Restaurantes", // translated
  notAvailable: "No disponible", // translated
  addressIsRequired: "La dirección es necesaria", // translated
  progressAt: "Progreso en", // translated
  km: "kilómetros", // translated
  noReservationsForThisProduct: "No hay reservas para este producto.", // translated
  status: "Estado", // translated
  star: "Estrella", // translated
  score: "Puntaje", // translated
  security: "Seguridad", // translated
  genderIsRequired: "Se requiere género", // translated
  downloadVoucher: "Descargar bono", // translated
  nearby: "Cercano", // translated
  yourReservationIsInProgress: "Tu reserva está en curso", // translated
  proceed: "Proceder", // translated
  stars: "Estrellas", // translated
  emailNotSentTryAgain: "¡Correo electrónico no enviado! Inténtalo de nuevo", // translated
  iHaveReadAgreeWithAbove: "He leído y estoy de acuerdo con lo anterior.", // translated
  cityIsRequired: "Se requiere ciudad", // translated
  visitSite: "Visitar sitio", // translated
  countryIsRequired: "Se requiere país", // translated
  active: "Activo", // translated
  sendCancellationEmail: "Enviar correo electrónico de cancelación", // translated
  clickHere: "haga clic aquí", // translated
  confirmed: "Confirmado", // translated
  privacyPolicy: "política de privacidad", // translated
  cancelled: "Cancelado", // translated
  pleaseCheckTheBox: "Marque la casilla para indicar que ha leído y está de acuerdo con la información proporcionada antes de continuar con el siguiente paso.", // translated
  firstNameMustContainAlphabetic: "El nombre debe contener únicamente caracteres alfabéticos", // translated
  hour: "hora", // translated
  firstNameIsRequired: "Se requiere el primer nombre", // translated
  emailIsRequired: "correo electronico es requerido", // translated
  phoneNumberIsRequired: "Se requiere número de teléfono", // translated
  sendUsRequest: "Envíanos tu solicitud", // translated
  leadGuest: "Invitado principal", // translated
  maintenanceTitle: "Sitio web en mantenimiento", // translated 
  maintenanceDescription:
    "Estamos realizando un mantenimiento programado. Vuelve pronto.", // translated 
  maintenanceCountdownLabel: "Tiempo restante estimado", // translated 
  maintenanceLogoAlt: "Logotipo del sitio web", // translated 
  maintenanceDays: "Días", // translated 
  maintenanceHours: "Horas", // translated 
  maintenanceMinutes: "Minutos", // translated 
  maintenanceSeconds: "Segundos", // translated 
  maintenanceStatusBadge: "Mantenimiento programado", // translated 
  maintenanceRefresh: "Actualizar página", // translated 
  maintenanceExpired:
    "El mantenimiento debería completarse en breve. Actualiza la página.", // translated 
};


export default commonAndMisc;
